// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3p1ru","question":"Question_question__3O7lO","description":"Question_description__1zVTQ"};